import { render, staticRenderFns } from "./CommentSheetImporter.vue?vue&type=template&id=65f192fb&scoped=true&class=comment-sheet-importer&"
import script from "./CommentSheetImporter.vue?vue&type=script&lang=js&"
export * from "./CommentSheetImporter.vue?vue&type=script&lang=js&"
import style0 from "./CommentSheetImporter.vue?vue&type=style&index=0&id=65f192fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f192fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFileInput } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VChip,VCol,VDialog,VFileInput,VForm,VListItem,VRow})
